import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  injectStripe,
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
} from 'react-stripe-elements';
import { Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import './EditCardForm.css';
import './PlanAndBilling.css';
import Strings from '../../common/Strings';
import { paymentActions } from '../../actions';
import config from '../../config';

class EditCardForm extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      cardComplete: false,
      expComplete: false,
      cvcComplete: false,
    };
  }
  componentDidMount() {
    this.props.dispatch(paymentActions.getPremiumClientSecret());
  }

  componentDidUpdate(prevProps) {
    if (this.props.paymentMethodId !== prevProps.paymentMethodId) {
      const stripe = window.Stripe(config.STRIPE_PUBLIC_KEY);
      stripe
        .handleCardSetup(this.props.clientSecret, {
          payment_method: this.props.paymentMethodId,
        })
        .then(result => {
          this.props.dispatch(
            paymentActions.attachPaymentMethod(result.setupIntent),
          );
          this.props.dispatch(paymentActions.paymentCardLoading(false));
          this.props.closeModal();
        });
    }
  }

  async handleSubmit(ev) {
    ev.preventDefault();
    if (this.props.stripe) {
      this.props.dispatch(paymentActions.paymentCardLoading(true));
      this.props.stripe.createToken().then(response => {
        const token = response.token;
        this.props.dispatch(paymentActions.createPaymentMethod(token));
      });
    }
  }

  render() {
    const createOptions = (fontSize, padding) => {
      return {
        style: {
          base: {
            fontSize,
            color: '#424770',
            letterSpacing: '0.025em',
            fontFamily: 'Arial',
            '::placeholder': {
              color: '#9b9b9b',
            },
            padding,
          },
          invalid: {
            color: '#9e2146',
          },
        },
      };
    };

    let cardButton;
    if (this.props.paymentCard) {
      cardButton = Strings.BILLING.updateCard;
    } else {
      cardButton = Strings.BILLING.addCard;
    }

    return (
      <form className="edit-card-form" onSubmit={this.handleSubmit}>
        <label className="edit-card-field">
          {Strings.BILLING.cardNumber}
          <CardNumberElement
            {...createOptions(this.props.fontSize)}
            onChange={({ complete }) => {
              this.setState({ cardComplete: complete });
            }}
          />
        </label>
        <div className="Card-Container">
          <label className="edit-card-field">
            {Strings.BILLING.expiration}
            <CardExpiryElement
              {...createOptions(this.props.fontSize)}
              onChange={({ complete }) => {
                this.setState({ expComplete: complete });
              }}
            />
          </label>
          <label className="edit-card-field" style={{ marginLeft: 10 }}>
            {Strings.BILLING.CVC}
            <CardCVCElement
              {...createOptions(this.props.fontSize)}
              onChange={({ complete }) => {
                this.setState({ cvcComplete: complete });
              }}
            />
          </label>
        </div>
        <div className="edit-card-bottom">
          <div className="edit-card-button-container">
            {this.props.paymentCard && (
              <a
                id="edit-card-delete-link"
                onClick={this.props.openDeleteModal}
                unselectable="true"
              >
                {Strings.BILLING.deleteCard}
              </a>
            )}
            <Button
              className="common-green-button-small"
              onClick={this.handleSubmit}
              loading={this.props.paymentCardLoading}
              disabled={
                !this.state.cardComplete ||
                !this.state.expComplete ||
                !this.state.cvcComplete
              }
            >
              {cardButton}
            </Button>
          </div>
        </div>
      </form>
    );
  }
}

EditCardForm.defaultProps = {
  paymentCard: null,
  clientSecret: null,
  paymentMethodId: '',
};

EditCardForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  stripe: PropTypes.shape({
    createToken: PropTypes.func.isRequired,
  }).isRequired,
  openDeleteModal: PropTypes.func.isRequired,
  paymentCard: PropTypes.shape({}),
  clientSecret: PropTypes.string.isRequired,
  paymentMethodId: PropTypes.string.isRequired,
  paymentCardLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  paymentCard: state.paymentCards.card,
  clientSecret: state.paymentCards.clientSecret,
  paymentMethodId: state.paymentCards.paymentMethodId,
  paymentCardLoading: state.paymentCards.loading,
});

export default injectStripe(connect(mapStateToProps)(EditCardForm));



// WEBPACK FOOTER //
// ./src/components/settings/EditCardForm.js